<template>
  <div id="emptyState" v-bind:class="`${viewStyle} ${viewSize}`">
    <div class="step-title">
      {{stateTitle}}
    </div>
    <div class="state-holder">
      <i class="material-icons-outlined grey-text text-lighten-1 csi">
        {{dataIcon}}
      </i>
    </div> 
    <div class="header-title ">
      <slot name="header">Empty Message</slot>
    </div>
    <div class="message-content" style="margin-bottom: 16px;" v-if="hasContent">
        <slot name="content">No Content for the desired block</slot>
    </div>
    <div class="center" v-if="showButton">
      <slot name="action">
        <button @click="$_emptyTrigger()" class="btn btn-rounded btn-medium indigo accent-2 waves-effect">
        <i class="material-icons-outlined left white-text">not_started</i>{{buttonText}}</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
name:'emptyState',
props:{
  showButton:{
    type: Boolean,
    default: false,
  },
  stateTitle:{
    type: String,
    default: ''
  },
   hasContent:{
    type:Boolean,
    default:false,
  },
  viewStyle:{
    type:String,
    default:''
  },
  viewSize:{
    type:String,
    default: 'small',
  },
  buttonText:{
    type:String,
    default: 'CONTINUE',
  },
  dataIcon:{
    type:String,
    default:'work_outline'
  },
},
methods:{
  $_emptyTrigger(e){
    this.$emit('action', true)
  }
}
}
</script>

<style lang="scss" scoped>
#emptyState {
  .state-holder {
    width: 250px;
    height: 250px;
    text-align: center;
    border-radius: 50%;
    margin: auto;
    background: #f3f3f3;
    i {
        font-size: 136px;
        line-height: 245px;
      }
  }

  .header-title {
    text-align: center;
    margin: 12px 0;
    font-size: 16.5px;
    font-family: "Libre Franklin", sans-serif;
  }
  .step-title {
    font-size: 24px;
    margin: 24px 0 24px;
    text-align: center;
  }
}

</style>
